import script from "./DateMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DateMenu.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__